module.exports = __webpack_public_path__ + "img/53.8f128c2a.png";